import { css } from 'styled-components'

type QueryParams = { minWidth?: number; maxWidth?: number; minRatio?: number; maxRatio?: number }

export const makeMediaQuery = (props: QueryParams) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const keyMap: { [index: string]: (...args: any[]) => string } = {
    minWidth: (px: number) => `(min-width: ${px}px)`,
    maxWidth: (px: number) => `(max-width: ${px}px)`,
    minRatio: (ratio: number) => `(-webkit-min-device-pixel-ratio: ${ratio})`,
    maxRatio: (ratio: number) => `(-webkit-max-device-pixel-ratio: ${ratio})`,
  }

  if (!props.maxWidth && !props.minWidth) {
    throw new Error('mediaQuery: both of maxWidth and minWidth was not provided. One of them is required')
  }

  return Object.entries(props)
    .map(([key, val]) => keyMap[key](val))
    .join(' and ')
}

export const mediaQuery = (query: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (...styles: any[]) => {
    return css`
      @media ${query} {
        ${// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        css(...styles)}
      }
    `
  }
}

type Breakpoints = {
  desktop: QueryParams
  smallDesktop: QueryParams
  tablet: QueryParams
  smallTablet: QueryParams
  mobile: QueryParams
}

export const creatMediaQueries = (breakpoints: Breakpoints) => {
  return {
    desktop: makeMediaQuery(breakpoints.desktop),
    smallDesktop: makeMediaQuery(breakpoints.smallDesktop),
    tablet: makeMediaQuery(breakpoints.tablet),
    smallTablet: makeMediaQuery(breakpoints.smallTablet),
    mobile: makeMediaQuery(breakpoints.mobile),
    custom: makeMediaQuery,
  }
}

export const createMedia = (breakpoints: Breakpoints) => {
  const queries = creatMediaQueries(breakpoints)

  return {
    desktop: mediaQuery(queries.desktop),
    tablet: mediaQuery(queries.tablet),
    smallTablet: mediaQuery(queries.smallTablet),
    smallDesktop: mediaQuery(queries.smallDesktop),
    mobile: mediaQuery(queries.mobile),
    custom: (props: QueryParams) => mediaQuery(makeMediaQuery(props)),
  }
}
